import axios from "axios";
import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";

import config from "@/App/config/main";
import AuthService from "@/Pages/Login/services/auth.service";
import { getTimeZone } from "@/App/utils/getTimeZone";

axios.defaults.headers.common.accept = "application/json";

export const HttpEngine: AxiosInstance = axios.create({
  baseURL: `${config.API_URL}/v4/`,
});

HttpEngine.interceptors.request.use((requestConfig: InternalAxiosRequestConfig) => {
  const token = AuthService.getAuthToken();

  if (token) {
    Object.assign(requestConfig.headers, { ...getAuthorizationHeader({ token }) });
  }

  if (requestConfig.headers) {
    requestConfig.headers["client-created-at"] = String(Date.now());
    requestConfig.headers["twiage-client-source"] = "hospital_dashboard";
    requestConfig.headers["timeZone"] = getTimeZone();
    requestConfig.headers["twiage-user-agent"] = "dashboard-2";
  }

  return requestConfig;
});

export const getAuthorizationHeader = ({ token }: { token: string }): { Authorization: string } => {
  return { Authorization: `JWT ${token}` };
};
